// The composer's text is component state, so anything that unmounts the chat
// takes an unsent message with it — a reload, a navigation, a session expiry.
// It is mirrored here, keyed by chat session, and read back on mount.
//
// Text only. An image attachment carries a base64 dataUrl, and a couple of
// those would exceed the origin's ~5MB quota and evict the auth token with it.

const PREFIX = "moderniser_chat_draft_"

// Long enough for any real message, short enough that a runaway paste cannot
// fill the quota on its own.
export const DRAFT_MAX_LENGTH = 100_000

export function draftStorageKey(sessionId: string): string {
  return `${PREFIX}${sessionId}`
}

export function draftFromStored(value: string | null | undefined): string {
  return value ?? ""
}

export function draftToStore(text: string): string {
  return text.slice(0, DRAFT_MAX_LENGTH)
}

export function readDraft(sessionId: string): string {
  if (!sessionId) return ""
  try {
    return draftFromStored(localStorage.getItem(draftStorageKey(sessionId)))
  } catch {
    return ""
  }
}

// An empty draft removes the key rather than storing "", so a composer nobody
// has typed in leaves nothing behind.
export function saveDraft(sessionId: string, text: string): void {
  if (!sessionId) return
  try {
    if (text === "") {
      localStorage.removeItem(draftStorageKey(sessionId))
      return
    }
    localStorage.setItem(draftStorageKey(sessionId), draftToStore(text))
  } catch {
    // The composer still works for this page when storage is unavailable or full.
  }
}

export function clearDraft(sessionId: string): void {
  if (!sessionId) return
  try {
    localStorage.removeItem(draftStorageKey(sessionId))
  } catch {
    // Nothing to do — the draft is already unreachable.
  }
}
